"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var memoize_one_1 = __importDefault(require("memoize-one"));
var round = function (n, decimals) {
    var power = Math.pow(10, decimals);
    return Math.round(n * power) / power;
};
var getD = function (values, viewBoxWidth, viewBoxHeight, decimals) {
    var l = [];
    var maxX = values.length - 1;
    var maxY = Math.max.apply(Math, __spread(values));
    for (var i = 0; i <= maxX; i++) {
        l.push(round(i / maxX * viewBoxWidth, decimals) + ',' +
            round(viewBoxHeight - (values[i] / maxY * viewBoxHeight), decimals));
    }
    return "M " + l.join(' L ');
};
var Sparkline = (function () {
    function Sparkline(values) {
        if (values === void 0) { values = []; }
        this._decimals = 4;
        this._desc = 'A line graph representation of a value\'s change over time.';
        this._fill = 'transparent';
        this._getD = memoize_one_1.default(getD);
        this._height = '100%';
        this._preserveAspectRatio = 'none';
        this._stroke = 'currentColor';
        this._strokeWidth = '1%';
        this._title = 'Sparkline';
        this._width = '100%';
        this._values = values;
        this._viewBoxHeight = 100;
        this._viewBoxWidth = 100;
    }
    Object.defineProperty(Sparkline.prototype, "d", {
        get: function () {
            return this._getD(this._values, this._viewBoxWidth, this._viewBoxHeight, this._decimals);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Sparkline.prototype, "dataUri", {
        get: function () {
            return "data:image/svg+xml;base64," + btoa(this.outerHTML);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Sparkline.prototype, "outerHTML", {
        get: function () {
            var fillPath = '';
            var strokePath = '';
            if (this._values.length !== 0) {
                strokePath = "\n        <path\n          d=\"" + this.d + "\"\n          fill=\"transparent\"\n          stroke=\"" + this._stroke + "\"\n          stroke-width=\"" + this._strokeWidth + "\"\n        />\n      ";
                if (this._fill !== 'transparent') {
                    var d = "L " + this._viewBoxWidth + "," + this._viewBoxHeight + " " +
                        ("L 0," + this._viewBoxHeight + " Z");
                    fillPath = "\n          <path\n            d=\"" + this.d + " " + d + "\"\n            fill=\"" + this._fill + "\"\n            stroke=\"transparent\"\n            stroke-width=\"0\"\n          />\n        ";
                }
            }
            return "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n      <svg\n        height=\"" + this._height + "\"\n        preserveAspectRatio=\"" + this._preserveAspectRatio + "\"\n        version=\"1.1\"\n        viewBox=\"0 0 " + this._viewBoxWidth + " " + this._viewBoxHeight + "\"\n        x=\"0px\"\n        xml:space=\"preserve\"\n        xmlns=\"http://www.w3.org/2000/svg\"\n        xmlns:xlink=\"http://www.w3.org/1999/xlink\"\n        y=\"0px\"\n        width=\"" + this._width + "\"\n      >\n        <title>" + this._title + "</title>\n        <desc>" + this._desc + "</desc>\n        " + fillPath + "\n        " + strokePath + "\n      </svg>\n    ";
        },
        enumerable: true,
        configurable: true
    });
    Sparkline.prototype.setDecimals = function (decimals) {
        this._decimals = decimals;
        return this;
    };
    Sparkline.prototype.setDesc = function (desc) {
        this._desc = desc;
        return this;
    };
    Sparkline.prototype.setDescription = function (desc) {
        this._desc = desc;
        return this;
    };
    Sparkline.prototype.setFill = function (fill) {
        this._fill = fill;
        return this;
    };
    Sparkline.prototype.setHeight = function (height) {
        this._height = height;
        return this;
    };
    Sparkline.prototype.setPreserveAspectRatio = function (preserveAspectRatio) {
        this._preserveAspectRatio = preserveAspectRatio;
        return this;
    };
    Sparkline.prototype.setStroke = function (stroke) {
        this._stroke = stroke;
        return this;
    };
    Sparkline.prototype.setStrokeWidth = function (strokeWidth) {
        this._strokeWidth = strokeWidth;
        return this;
    };
    Sparkline.prototype.setTitle = function (title) {
        this._title = title;
        return this;
    };
    Sparkline.prototype.setValues = function (values) {
        this._values = values;
        return this;
    };
    Sparkline.prototype.setViewBoxHeight = function (viewBoxHeight) {
        this._viewBoxHeight = viewBoxHeight;
        return this;
    };
    Sparkline.prototype.setViewBoxWidth = function (viewBoxWidth) {
        this._viewBoxWidth = viewBoxWidth;
        return this;
    };
    Sparkline.prototype.setWidth = function (width) {
        this._width = width;
        return this;
    };
    return Sparkline;
}());
exports.default = Sparkline;
